var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembership2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM8.25 5a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM6 11.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM2.25 14a3.75 3.75 0 015.987-3.01 2.997 2.997 0 012.013-.74h3.5a3 3 0 012.013.74 3.75 3.75 0 11-1 1.117 1.508 1.508 0 00-1.013-.357h-3.5c-.437 0-.77.149-1.012.357A3.75 3.75 0 112.25 14zM18 11.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM3.114 21.228c-.267.288-.364.613-.364.772a.75.75 0 01-1.5 0c0-.59.278-1.267.762-1.79a2.99 2.99 0 012.238-.96h3.5a2.99 2.99 0 012.239.96c.483.524.761 1.2.761 1.79a.75.75 0 01-1.5 0c0-.16-.097-.484-.364-.773-.246-.266-.614-.477-1.136-.477h-3.5c-.522 0-.89.211-1.136.478zm12 0c-.267.288-.364.613-.364.772a.75.75 0 01-1.5 0c0-.59.278-1.267.762-1.79a2.99 2.99 0 012.238-.96h3.5a2.99 2.99 0 012.239.96c.483.524.761 1.2.761 1.79a.75.75 0 01-1.5 0c0-.16-.097-.484-.364-.773-.245-.266-.614-.477-1.136-.477h-3.5c-.522 0-.89.211-1.136.478z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership2);
export default __webpack_public_path__ + "static/media/Membership2.29b915d53be30a4c8b32463db44c9bb7.svg";
export { ForwardRef as ReactComponent };